import { SupplierManagementImpl } from "../data/SupplierManagementImpl";
import { ISupplierManagementRepository } from "../domain/repositories/ISupplierManagementRepository";
import { SupplierManagementUseCase } from "../domain/useCases/SupplierManagementUseCase";
import { SupplierManagementViewModel } from "../presentation/viewModel/SupplierManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class SupplierManagementInjection extends InjectionModule {
  private static readonly supplierManagementRepositoryToken = Symbol(
    "ISupplierManagementRepository",
  );
  private static readonly supplierManagementUseCaseToken = Symbol(
    "SupplierManagementUseCase",
  );
  private static readonly supplierManagementViewModelToken = Symbol(
    "SupplierManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.supplierManagementRepositoryToken,
      useClass: SupplierManagementImpl,
    },
    {
      scope: "otherRepo",
      token: this.supplierManagementUseCaseToken,
      useClass: SupplierManagementUseCase,
    },
    {
      scope: "viewModel",
      token: this.supplierManagementViewModelToken,
      useClass: SupplierManagementViewModel,
    },
  ];

  static getRepo(): ISupplierManagementRepository {
    return this.resolve(this.supplierManagementRepositoryToken);
  }

  static getUseCase(): SupplierManagementUseCase {
    return this.resolve(this.supplierManagementUseCaseToken);
  }
}
